import React from "react";

import { NavLink } from "react-router-dom";
import HeaderMenuControllato from "./HeaderMenuControllato";
import { Routes_path } from "../../routerApp";
import { PermissionTypes } from "../../../components/authentication/permissionsGroups";


import { useTheme } from "@mui/material/styles";
import ProfileMenu from "./ProfileMenu";
import { userIsLogged } from "../UserIsLogged";

import IconButton from "@mui/material/IconButton";
import LoginIcon from "@mui/icons-material/Login";
import HomeIcon from "@mui/icons-material/Home";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import StorefrontTwoToneIcon from "@mui/icons-material/StorefrontTwoTone";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {UtenteLogged} from "../../authentication/authenticationSlice";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {PreferenzeLista} from "../../userPreference/userPreferenceSlice";

const MenuItemStyle = {
	display: { sm: "inline-flex", xs: "flex" },
	padding: 0,
	ml: 1,
	color: "#ddd",
};

export enum Orientation {
	Horizontal = "horizontal",
	Vertical = "vertical",
}

interface HeaderMenuProps {
	utente: UtenteLogged;
	resetUtente: () => void;
	orientation: Orientation;
	activeStyle: React.CSSProperties;
}

const HeaderMenu = ({
	utente,
	resetUtente,
	orientation,
	activeStyle,
}: HeaderMenuProps) => {
	const theme = useTheme();

	return (
		<>
			<Button
				aria-controls="simple-menu"
				component={NavLink}
				size="small"
				// activeStyle={activeStyle}
				// exact
				// color="secondary"
				to="/"
				sx={{ ml: 1, color: theme.palette.text.secondary }}
			>
				Homepage
				<IconButton aria-label="show 4 new mails" size="large" color="inherit">
					<Badge badgeContent={0}>
						<HomeIcon />
					</Badge>
				</IconButton>
			</Button>


			{/*<HeaderMenuControllato*/}
			{/*	utente={utente}*/}
			{/*	path={Routes_path.TASKS}*/}
			{/*	state={{*/}
			{/*		completato_ambiente: false,*/}
			{/*	}}*/}
			{/*	label=""*/}
			{/*	tooltipLabel="Task"*/}
			{/*	gruppiAutorizzati={[*/}
			{/*		PermissionTypes.ALL,*/}
			{/*	]}*/}
			{/*	Icon={TaskAltIcon}*/}
			{/*	badgeContent={conteggioTaskAttivi}*/}
			{/*/>*/}

			{userIsLogged(utente) ? (
				<Box sx={MenuItemStyle}>
					<ProfileMenu/>
				</Box>
			) : (
				<Button
					aria-controls="simple-menu"
					component={NavLink}
					size="small"
					// activeStyle={activeStyle}
					// exact
					// color="inherit"
					to="/signin/"
					sx={{ ml: 1, color: theme.palette.text.primary  }}
				>
					accedi
					<IconButton
						aria-label="account of current user"
						aria-controls="primary-search-account-menu"
						aria-haspopup="true"
						color="inherit"
						size="large"
					>
						<LoginIcon />
					</IconButton>
				</Button>
			)}
		</>
	);
};

export default HeaderMenu;
